import { select, call, takeLatest, all, put } from 'redux-saga/effects';
import { SeanceActions } from '../constants';
import { SeanceApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import history from 'src/navigation/history';
import { PaginationService } from '../../services/api-handlers/pagination';
import {
    DeleteSeanceAction,
    GetSeanceAction,
    GetSeancesAction,
    GetSeancesStatisticsAction,
    PersistSeanceAction,
    CreateFilesSeanceAction,
    GetFilesAction,
    DeleteFileSeanceAction,
    MoveToOccasionSeanceAction,
    SignSeanceAction,
    UpdateSeanceAction,
    GetMultiSeancesAction,
    GetCopySeanceAction,
    GetSeancesListAction,
} from '../actions/seance-actions';
import sortingService from '../../services/sorting';
import { groupSeance } from 'src/helpers/seance';
import {
    failureType,
    getErrorMessage,
    handleError,
    requestType,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
    successType,
} from '../../services/api-handlers/api-resolver';
import { SubmissionError } from 'redux-form';
import { makeFormErrors } from '../../components/redux-form/utils/make-form-errors';
import { convertValuesToFormData } from '../../components/redux-form/utils/values-to-form-data';
import { toast } from 'react-toastify';
import { changeToZeroMomentDate } from '../../helpers/timeHelpers';
import { GetExpensesAction } from '../actions/expense-actions';
import { groupSeanceToCsv } from '../../helpers/seance/groupSeancePage';

import { exportToCsv } from '../../services/exports/csv';

import Router from '../../navigation/router';
import routes from '../../navigation/routes';
import { ISeance } from '../../types/seance';
import { AxiosResponse } from 'axios';
import { useCookies } from 'react-cookie';
import isArray from 'lodash/isArray';
import { isObject } from 'lodash';

function* handleFetchSeances(action: GetSeancesAction) {
    const oldData = yield select((state: StoreState) => state.seances.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    let filterProps: any = { status: [1, 3, 4, 8], ...filters };

    if (filters?.dateNoPeriod && filters?.dateNoPeriod == 1) {
        if (filters?.seanceDate && isObject(filters?.seanceDate)) {
            const seanceDateVar: any = filters.seanceDate;
            filterProps = {
                status: [1, 3, 4, 8],
                ...filters,
                // 'seanceDate[before]': changeToZeroMomentDate(`${seanceDateVar['seanceDate[before]']}`),
                'seanceDate[after]': changeToZeroMomentDate(`${seanceDateVar['seanceDate[after]']}`),
            };
            delete filterProps.seanceDate;
        } else if (filters?.seanceDate) {
            filterProps = {
                status: [1, 3, 4, 8],
                ...filters,
                //'seanceDate[before]': changeToZeroMomentDate(`${filters.seanceDate}`),
                'seanceDate[after]': changeToZeroMomentDate(`${filters.seanceDate}`),
            };
            delete filterProps.seanceDate;
        }
    } else {
        if (filters?.seanceDate && isObject(filters?.seanceDate)) {
            const seanceDateVar: any = filters.seanceDate;
            filterProps = {
                status: [1, 3, 4, 8],
                ...filters,
                'seanceDate[before]': changeToZeroMomentDate(`${seanceDateVar['seanceDate[before]']}`),
                'seanceDate[after]': changeToZeroMomentDate(`${seanceDateVar['seanceDate[after]']}`),
            };
            delete filterProps.seanceDate;
        } else if (filters?.seanceDate) {
            filterProps = {
                status: [1, 3, 4, 8],
                ...filters,
                'seanceDate[before]': changeToZeroMomentDate(`${filters.seanceDate}`),
                'seanceDate[after]': changeToZeroMomentDate(`${filters.seanceDate}`),
            };
            delete filterProps.seanceDate;
        }
    }

    if (filters?.confirmationDate && isObject(filters?.confirmationDate)) {
        const confirmationDateVar: any = filters.confirmationDate;
        filterProps = {
            status: [1, 3, 4, 8],
            ...filters,
            //
            'confirmationDate[before]': changeToZeroMomentDate(`${confirmationDateVar['confirmationDate[before]']}`),
            'confirmationDate[after]': changeToZeroMomentDate(`${confirmationDateVar['confirmationDate[after]']}`),
        };
        delete filterProps.confirmationDate;
    } else if (filters?.confirmationDate) {
        filterProps = {
            status: [1, 3, 4, 8],
            ...filters,
            'confirmationDate[before]': changeToZeroMomentDate(`${filters.confirmationDate}`),
            'confirmationDate[after]': changeToZeroMomentDate(`${filters.confirmationDate}`),
        };
        delete filterProps.confirmationDate;
    }

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        SeanceApi.getSeances({
            ...filterProps,
            ...sortingService.makeOrderSymfony(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchSeancesList(action: GetSeancesListAction) {
    const oldData = yield select((state: StoreState) => state.seancesList.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    let filterProps: AnyObject = { status: [1, 3, 4, 8], ...filters };

    if (filters?.seanceDate) {
        filterProps = {
            status: [1, 3, 4, 8],
            ...filters,
            'seanceDate[before]': changeToZeroMomentDate(`${filters.seanceDate}`),
            'seanceDate[after]': changeToZeroMomentDate(`${filters.seanceDate}`),
        };
        delete filterProps.seanceDate;
    }
    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        SeanceApi.getSeances({
            ...filterProps,
            ...sortingService.makeOrderSymfony(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchSeancesCsv(action: GetSeancesAction): any {
    const { filters, sorting, itemsPerPage } = action.payload;
    let page: number = action?.payload?.page ? +action.payload.page : 1;
    const filtersVar: any = filters;
    // let filterProps: AnyObject = { ...filters };
    let filterProps: AnyObject = { status: [1, 3, 4, 8], ...filters };

    if (filtersVar?.seanceDate) {
        if (filtersVar?.seanceDate['seanceDate[after]']) {
            filterProps = {
                status: [1, 3, 4, 8],
                ...filters,
                'seanceDate[before]': changeToZeroMomentDate(`${filtersVar?.seanceDate['seanceDate[before]']}`),
                'seanceDate[after]': changeToZeroMomentDate(`${filtersVar?.seanceDate['seanceDate[after]']}`),
            };
        } else {
            filterProps = {
                status: [1, 3, 4, 8],
                ...filters,
                'seanceDate[before]': changeToZeroMomentDate(`${filters?.seanceDate}`),
                'seanceDate[after]': changeToZeroMomentDate(`${filters?.seanceDate}`),
            };
        }
        delete filterProps.seanceDate;
    }
    yield resolveApiCall(
        action,
        () =>
            SeanceApi.getSeances({
                ...filterProps,
                order: sortingService.makeOrder(sorting),
                page,

                itemsPerPage: 60,
                pagination: itemsPerPage === -1 ? 0 : 1,
            }),
        function* (data) {
            if (data.payload.length === 60) {
                const actionFiles: GetExpensesAction = {
                    type: SeanceActions.FETCH_SEANCES_CSV,
                    payload: {
                        filters: filterProps,
                        ...filterProps,
                        page: ++page,
                        sorting,
                        itemsPerPage: 60,
                    },
                    all: action.all ? [...action.all, ...data.payload] : [...data.payload],
                };

                yield call(handleFetchSeancesCsv, actionFiles);
            } else {
                const dataAll = action.all ? [...action.all, ...data.payload] : [...data.payload];
                if (action.all) {
                    const groupCsv = groupSeanceToCsv(dataAll);
                    exportToCsv('sessions.csv', groupCsv);
                } else {
                    const groupCsvData = groupSeanceToCsv(data.payload);
                    const actionResult = {
                        payload: {},
                        type: successType(SeanceActions.FETCH_SEANCES_CSV),
                    };

                    yield put(actionResult);
                    exportToCsv('sessions.csv', groupCsvData);
                }
            }
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                const actionResult = {
                    payload: {},
                    type: failureType(SeanceActions.FETCH_SEANCES_CSV),
                };
                yield put(actionResult);
            }
            handleError(result);
        },
    );
}
function* handleFetchMultiSeances(action: GetMultiSeancesAction) {
    const { filters = [], sorting, itemsPerPage } = action.payload;
    let page: number = action?.payload?.page ? +action.payload.page : 1;
    const calls: any[] = [];
    try {
        const actionReq = {
            type: requestType(SeanceActions.FETCH_MULTI_SEANCE),
        };

        yield put(actionReq);

        filters.forEach((item: AnyStringNumObject) => {
            calls.push(
                call(SeanceApi.getSeances, {
                    ...item,
                    order: sortingService.makeOrder(sorting),
                    page,
                    itemsPerPage,
                    pagination: itemsPerPage === -1 ? 0 : 1,
                }),
            );
        });

        const res = yield all(calls);

        const getAllSeances = async (itemParam: AxiosResponse<ISeance[]>, filter: AnyStringNumObject) => {
            if (itemParam.data.length === 80) {
                const res: AxiosResponse<ISeance[]> = await SeanceApi.getSeances({
                    ...filter,
                    order: sortingService.makeOrder(sorting),

                    page: ++page,
                    itemsPerPage: 80,
                    pagination: itemsPerPage === -1 ? 0 : 1,
                });

                if (res?.data?.length === 80) {
                    const resSeance: AxiosResponse<ISeance[]> = await getAllSeances({ ...itemParam, ...res }, filter);

                    return { ...itemParam, data: [...itemParam.data, ...resSeance.data] };
                } else {
                    return { ...itemParam, data: [...itemParam.data, ...res.data] };
                }
            } else {
                return itemParam;
            }
        };

        const resDataPR: AnyObject[] = res.map(async (itD: AxiosResponse<ISeance[]>, n: number) => {
            const resSeance = await getAllSeances(itD, filters[n]);

            return resSeance.data;
        });

        const resArr = yield all(resDataPR);
        const resData: AnyObject[] = [].concat.apply([], resArr);
        const unique = resData.filter((obj, pos, arr) => {
            return arr && arr.map((mapObj) => mapObj['id']).indexOf(obj['id']) === pos;
        });

        const actionResult = {
            payload: {
                list: unique,
                page: 1,
                meta: {
                    updatedAt: null,
                },
            },
            type: successType(SeanceActions.FETCH_SEANCES),
        };

        yield put(actionResult);
    } catch (e) {
        toast.error(e.error?.response?.data?.detail ?? 'Incorrect response');
        const actionFail = {
            payload: {},
            type: failureType(SeanceActions.FETCH_SEANCES),
        };
        yield put(actionFail);
    }
}
function* handleFetchSeance(action: GetSeanceAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => SeanceApi.getSeance(id));
}
function* handleCopyNoteSeance(action: GetCopySeanceAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => SeanceApi.getSeance(id));
}

export function* handleFetchUnconfirmed(action: GetSeancesAction) {
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield resolveApiCall(action, () =>
        SeanceApi.getunconfirmedSeance({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

// /api/

function* handleSeanceStatistics(action: GetSeancesStatisticsAction) {
    const {
        payload: { params },
    } = action;
    yield resolveApiCall(action, () => SeanceApi.getSeancesStatistics(params));
}

function* handleDeleteSeance(action: DeleteSeanceAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => SeanceApi.deleteSeance(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handleMoveSeance(action: MoveToOccasionSeanceAction) {
    const {
        payload: { data, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => SeanceApi.moveToOccasionSeance(`${data.id}`, { occasionId: data.occasion }),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error?.response?.data?.detail ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handleSignSeance(action: SignSeanceAction) {
    const {
        payload: { data, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => SeanceApi.signSeance(`${data.id}`),
        function* (dataRes) {
            if (onSuccess) {
                onSuccess();
                yield put({ type: successType(SeanceActions.UPDATE_SEANCE), payload: { ...dataRes?.payload } });
                if (dataRes?.payload?.status && +dataRes.payload.status !== 4) {
                    if (data.seanceFuture) {
                        toast.error(`You can’t confirm future sessions`);
                    } else {
                        toast.error(`The session can’t be confirmed until the previous sessions are confirmed.`);
                    }
                } else {
                    const actionSeance: GetSeancesAction = {
                        type: SeanceActions.FETCH_UNCONFIRMED_SEANCES,
                        payload: {},
                    };
                    yield call(handleFetchUnconfirmed, actionSeance);
                }
            }
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error?.response?.data?.detail ?? 'Unknown error');
                    yield put({ type: failureType(SeanceActions.SIGN_SEANCE), payload: {} });
                }
            }
            handleError(result);
        },
    );
}

function* handleCreateFilesSeance(action: CreateFilesSeanceAction) {
    const {
        payload: { id, files, isDatasheet, onSuccess, onError },
    } = action;

    const requestFunction: any = (file: any) => {
        const objToForm = { seance: id, attachFile: file, isDatasheet };
        const formData = convertValuesToFormData(objToForm);
        return SeanceApi.createFilesSeance(formData);
    };

    for (let i = 0; i < files.length; i++) {
        if (files[i]?.id || files[i]?.attach || !files[i].type) {
            continue;
        }

        yield resolveApiCall(
            action,
            () => requestFunction(files[i]),
            function (data: ResolverApiSuccess) {
                if (onSuccess) {
                    onSuccess();
                }
            },
            function (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    if (onError) {
                        onError(result.error?.response?.data?.detail ?? 'Unknown error');
                    }
                }
            },
        );
    }
}

function* handleUpdateSeance(action: UpdateSeanceAction) {
    const {
        payload: { data, onSuccess, onError },
    } = action;

    const { id, editMode, ...restDate } = data;
    yield resolveApiCall(
        action,
        () => SeanceApi.updateSeance(`${id}`, restDate),
        function* (res) {
            if (onSuccess) {
                if (editMode) {
                    yield put({ type: successType(SeanceActions.UPDATE_SEANCE), payload: data });
                    onSuccess();
                } else {
                    if (data?.status && +data.status !== 4 && +res.payload.status === 4) {
                        const actionSeance: GetSeancesAction = {
                            type: SeanceActions.FETCH_UNCONFIRMED_SEANCES,
                            payload: {},
                        };
                        yield call(handleFetchUnconfirmed, actionSeance);
                    }
                    yield put({ type: successType(SeanceActions.UPDATE_SEANCE), payload: data });
                    onSuccess();
                }
            }
        },
        function* (result: ResolverApiFailure) {
            yield put({ type: failureType(SeanceActions.UPDATE_SEANCE), error: result?.error?.message });
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error?.response?.data?.detail ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handleUpdateSeanceNote(action: PersistSeanceAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        callbacks,
    } = payload;
    yield resolveApiCall(
        action,
        () => SeanceApi.updateSeanceNote(id, restData),
        function* (data: ResolverApiSuccess) {
            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                yield call(callbacks.reject, {
                    _error: result.error.message ?? 'Incorrect response',
                    ...makeFormErrors(result.error.response?.data),
                });

                toast.error(result.error?.response?.data?.detail ?? 'Incorrect response');
            }
            handleError(result);
        },
    );
}

function* handleUpdateSeanceInTime(action: PersistSeanceAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        callbacks,
    } = payload;
    yield resolveApiCall(
        action,
        () => SeanceApi.updateSeanceInTime(id, restData),
        function* (data: ResolverApiSuccess) {
            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                yield call(callbacks.reject, {
                    _error: result.error.message ?? 'Incorrect response',
                    ...makeFormErrors(result.error.response?.data),
                });

                toast.error(result.error?.response?.data?.detail ?? 'Incorrect response');
            }
            handleError(result);
        },
    );
}

function* handleUpdateLocation(action: PersistSeanceAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        callbacks,
    } = payload;
    yield resolveApiCall(
        action,
        () => SeanceApi.updateSeance(`${id}`, restData),
        function* (data: ResolverApiSuccess) {
            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                yield call(callbacks.reject, {
                    _error: result.error.message ?? 'Incorrect response',
                    ...makeFormErrors(result.error.response?.data),
                });

                toast.error(result.error?.response?.data?.detail ?? 'Incorrect response');
            }
            handleError(result);
        },
    );
}

function* handlePersistSeance(action: PersistSeanceAction) {
    const { payload } = action;
    const {
        data: {
            id,
            columnForm,
            providerId,
            studentId,
            districtId,
            vendorId,
            providerCalendar,
            studentCalendar,
            detailPage,
            ...restData
        },
        files,
        callbacks,
    } = payload;

    const dataSeance = groupSeance(restData);
    yield resolveApiCall(
        action,
        () => (id ? SeanceApi.updateSeance(id, dataSeance) : SeanceApi.createSeance({ ...dataSeance, status: 1 })),
        function* (data: ResolverApiSuccess) {
            const actionFiles: CreateFilesSeanceAction = {
                type: SeanceActions.CREATE_FILES_SEANCE,
                payload: {
                    id: data.payload.id,
                    requestType: 'OTHER',
                    files: files.files,
                    isDatasheet: false,
                    onSuccess: () => false,
                    onError: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            };
            if (files.files && files.files?.length) {
                yield call(handleCreateFilesSeance, actionFiles);
            }
            if (!columnForm) {
                if (providerCalendar) {
                    const actionFiles: GetSeancesAction = {
                        type: 'fetch_seances',
                        payload: {
                            filters: {
                                'provider.id': dataSeance.provider?.id,
                                'seanceDate[after]': dataSeance?.month.monthStart, //2020-12-1
                                'seanceDate[before]': dataSeance?.month.monthEnd, //2020-12-31
                            },
                            itemsPerPage: 1200,
                            page: 1,
                        },
                    };
                    yield call(handleFetchSeances, actionFiles);
                } else if (studentCalendar) {
                    const actionFiles: GetSeancesAction = {
                        type: 'fetch_seances',
                        payload: {
                            filters: {
                                'student.id': dataSeance.student?.id,
                                showAll: '1',
                                providers: dataSeance.providers,
                                'seanceDate[after]': dataSeance?.month.monthStart, //2020-12-1
                                'seanceDate[before]': dataSeance?.month.monthEnd, //2020-12-31
                            },
                            itemsPerPage: 1200,
                            page: 1,
                        },
                    };
                    yield call(handleFetchSeances, actionFiles);
                } else {
                    let client: { [key: string]: number } = { 'student.id': 0 };
                    if (studentId) {
                        client = {
                            'student.id': +studentId,
                        };
                    } else if (districtId) {
                        client = {
                            'district.id': +districtId,
                        };
                    } else {
                        client = {
                            'vendor.id': vendorId ? +vendorId : 0,
                        };
                    }
                    const filters: any = [
                        {
                            'provider.id': providerId,
                        },
                        {
                            ...client,
                        },
                    ];

                    const actionFiles: GetSeancesAction = {
                        type: 'fetch_multi_seances',
                        payload: {
                            filters: filters,
                            itemsPerPage: 1200,
                            page: 1,
                        },
                    };

                    yield call(handleFetchMultiSeances, actionFiles);
                }
            } else {
                toast.success(`Session was successfully ${!id ? 'created' : 'updated'}.`);
                const actionFiles: GetSeancesAction = {
                    type: 'fetch_seances',
                    payload: {
                        filters: {
                            'occasion.id': dataSeance.occasion,
                            'order[seanceDate]': 'asc',

                            'provider.id': providerId,
                            'seanceDate[after]': dataSeance?.month?.monthStart, //2020-12-1
                            'seanceDate[before]': dataSeance?.month?.monthEnd, //2020-12-31
                        },
                        itemsPerPage: 1200,
                        page: 1,
                    },
                };

                if (!detailPage) {
                    yield call(handleFetchSeances, actionFiles);
                }
            }

            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (columnForm) {
                    yield call(callbacks.reject, {
                        _error: getErrorMessage(result),
                        ...makeFormErrors(result.error.response?.data),
                    });

                    toast.error(getErrorMessage(result));
                } else {
                    if (result?.error?.code && +result.error.code === 401) {
                        history.push(Router.generate(routes.LOGOUT), {});
                    }
                    toast.error(getErrorMessage(result));
                    yield call(
                        callbacks.reject,
                        result.error instanceof SubmissionError
                            ? result.error
                            : new SubmissionError({
                                  _error: getErrorMessage(result),
                                  ...makeFormErrors(result.error.response?.data),
                              }),
                    );
                }
            }
            handleError(result);
        },
    );
}

function* handleDeleteFileSeance(action: DeleteFileSeanceAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => SeanceApi.deleteFileSeance(id),
        function (data) {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}
function* handleGetFilesSeance(action: GetFilesAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => SeanceApi.getFilesSeance(id));
}

export default function* () {
    yield takeLatest(SeanceActions.FETCH_SEANCES, handleFetchSeances);
    yield takeLatest(SeanceActions.FETCH_SEANCES_LIST, handleFetchSeancesList);
    yield takeLatest(SeanceActions.FETCH_SEANCES_CSV, handleFetchSeancesCsv);
    yield takeLatest(SeanceActions.FETCH_UNCONFIRMED_SEANCES, handleFetchUnconfirmed);
    yield takeLatest(SeanceActions.FETCH_SEANCE, handleFetchSeance);
    yield takeLatest(SeanceActions.COPY_NOTE_SEANCE, handleCopyNoteSeance);
    yield takeLatest(SeanceActions.DELETE_SEANCE, handleDeleteSeance);
    yield takeLatest(SeanceActions.PERSIST_SEANCE, handlePersistSeance);
    yield takeLatest(SeanceActions.FETCH_SEANCE_STATISTICS, handleSeanceStatistics);
    yield takeLatest(SeanceActions.UPDATE_SEANCE_NOTE, handleUpdateSeanceNote);
    yield takeLatest(SeanceActions.UPDATE_SEANCE_IN_TIME, handleUpdateSeanceInTime);
    yield takeLatest(SeanceActions.UPDATE_LOCATION, handleUpdateLocation);
    yield takeLatest(SeanceActions.DELETE_FILE_SEANCE, handleDeleteFileSeance);
    yield takeLatest(SeanceActions.CREATE_FILES_SEANCE, handleCreateFilesSeance);
    yield takeLatest(SeanceActions.FETCH_FILES_SEANCE, handleGetFilesSeance);
    yield takeLatest(SeanceActions.MOVE_TO_OCCASION_SEANCE, handleMoveSeance);
    yield takeLatest(SeanceActions.SIGN_SEANCE, handleSignSeance);
    yield takeLatest(SeanceActions.UPDATE_SEANCE, handleUpdateSeance);
    yield takeLatest(SeanceActions.FETCH_MULTI_SEANCE, handleFetchMultiSeances);
}
